import { MARQUEE_WORDS } from "@/lib/landing";
import { Leaf } from "lucide-react";

export default function Marquee() {
  const items = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <div className="relative z-10 border-y border-[var(--ld-line)] bg-[var(--ld-surface)]/40 py-5">
      <div className="ld-marquee-track">
        {items.map((w, i) => (
          <span key={i} className="ld-display flex items-center gap-6 px-6 text-2xl text-[var(--ld-text)]/70 sm:text-3xl">
            {w}
            <Leaf className="h-5 w-5 text-[var(--ld-lime)]" />
          </span>
        ))}
      </div>
    </div>
  );
}
